import { graphql, useStaticQuery } from 'gatsby';
import { getDrupalMenu } from '@lucid/utils';
import { type I18n } from 'types/types';

export const useMenuProductSuite = (languageKey: I18n.AvailableLanguagesKey) =>
  getDrupalMenu(
    useStaticQuery(
      graphql`
        {
          coDrupal {
            menuLinkContentQuery(
              limit: 10000
              sort: [{ field: "parent", direction: ASC }, { field: "weight", direction: ASC }]
              filter: {
                conjunction: OR
                groups: [
                  { groups: [{ conditions: [{ field: "bundle", value: "product-suite", operator: EQUAL }] }] }
                  {
                    groups: [
                      { conditions: [{ field: "bundle", value: "top-navigation", operator: EQUAL }] }
                      {
                        conjunction: OR
                        conditions: [
                          # this is the id for the parent company
                          { field: "uuid", value: "7b13f5cc-223a-4e27-b186-4ddcc95344db", operator: EQUAL }
                          {
                            field: "parent"
                            value: "menu_link_content:7b13f5cc-223a-4e27-b186-4ddcc95344db"
                            operator: EQUAL
                          }
                          # this is the id for the parent label for all links "about lucid software"
                          { field: "uuid", value: "1e464afe-fec4-42a2-a098-b3f569c1a91d", operator: EQUAL }
                          {
                            field: "parent"
                            value: "menu_link_content:1e464afe-fec4-42a2-a098-b3f569c1a91d"
                            operator: EQUAL
                          }
                          # this is the id for the parent label for all links "our data solutions"
                          { field: "uuid", value: "640298c7-c368-4f5f-b8ec-816672acf048", operator: EQUAL }
                          {
                            field: "parent"
                            value: "menu_link_content:640298c7-c368-4f5f-b8ec-816672acf048"
                            operator: EQUAL
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ) {
              entities {
                ...useMenuProductSuiteHook
              }
            }
          }
        }
      `,
    ),
    languageKey,
    'co',
  );

export const query = graphql`
  fragment useMenuProductSuiteHook on CoDrupal_MenuLinkContent {
    entityUuid
    entityId
    entityBundle
    parent
    link {
      url {
        ...getLinkPathCo
      }
    }
    entityTranslations {
      entityLanguage {
        id
      }
      ... on CoDrupal_MenuLinkContent {
        title
      }
      ...useMenuTopNavigationCo
      ...useMenuProductSuiteCo
    }
  }
  fragment getLinkPathCo on CoDrupal_Url {
    path
    ... on CoDrupal_EntityCanonicalUrl {
      entity {
        entityUrl {
          path
        }
        entityTranslations {
          ... on CoDrupal_Node {
            langcode {
              value
            }
            status
            entityUrl {
              path
            }
          }
        }
      }
    }
  }
  fragment useMenuTopNavigationCo on CoDrupal_MenuLinkContentTopNavigation {
    isEnabled: enabled
    description
    fieldProductLink
    fieldDisableLanguage
    fieldBeaconElementDetail
    fieldDropdownTitle
    fieldDropdownDescription
    fieldDropdownFeaturedItem {
      entity {
        entityTranslations {
          ... on CoDrupal_ParagraphMenuFeaturedItem {
            langcode {
              value
            }
            fieldAlt
            fieldImageUrl
            fieldTitle
            fieldSubtitle
            fieldResourceLink {
              url {
                ...getLinkPathCo
              }
            }
          }
        }
      }
    }
  }
  fragment useMenuProductSuiteCo on CoDrupal_MenuLinkContentProductSuite {
    isEnabled: enabled
    description
    fieldProductLink
    fieldDisableLanguage
    fieldBeaconElementDetail
    fieldIsExternalSourceLink
    fieldIsExternalSourceLinkTi
    fieldDropdownTitle
    fieldDropdownDescription
    fieldProductLogoImage {
      entity {
        ... on CoDrupal_ParagraphSeoImage {
          fieldImageLink
          fieldAltText
        }
      }
    }
    fieldDropdownFeaturedItem {
      entity {
        entityTranslations {
          ... on CoDrupal_ParagraphMenuFeaturedItem {
            langcode {
              value
            }
            fieldAlt
            fieldImageUrl
            fieldTitle
            fieldSubtitle
            fieldResourceLink {
              url {
                ...getLinkPathCo
              }
            }
          }
        }
      }
    }
  }
`;
